module.exports = __webpack_public_path__ + "static/media/code42.ef3639ec.png";